import { IGetSuggestedFaqsDTO, SuggestedFaqStatus } from '@/models/suggestedFaq.model';
import { PaginationFields } from '@/models/pagination.model';
import { SUGGESTED_FAQ_DEFAULT_SORT } from '../helpers/constants';

class GetSuggestedFaqsDTO implements IGetSuggestedFaqsDTO {
  question?: string;

  answer?: string;

  channelId?: number;

  status?: SuggestedFaqStatus;

  sort: string;

  [PaginationFields.PAGE]?: number;

  [PaginationFields.PAGE_SIZE]?: number;

  constructor({
    page = 1,
    question,
    answer,
    channelId,
    status,
  }: {
    page?: number;
    question?: string;
    answer?: string;
    channelId?: number;
    status?: SuggestedFaqStatus;
  } = {}) {
    this.question = question;
    this.answer = answer;
    this.channelId = channelId;
    this.status = status;
    this.sort = SUGGESTED_FAQ_DEFAULT_SORT;
    this[PaginationFields.PAGE] = page;
    this[PaginationFields.PAGE_SIZE] = 10;
  }
}

export default GetSuggestedFaqsDTO;
